import { useLayoutEffect as useReactLayoutEffect, useEffect } from 'react';

const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

/**
 * useLayoutEffect for SSR apps.
 * https://remix.run/docs/en/main/guides/constraints#uselayouteffect
 */
export const useLayoutEffect = canUseDOM ? useReactLayoutEffect : useEffect;
